<ng-container [formGroup]="formGroup">
  @if (label) {
  <label class="input-dropdown-label">{{ label }}</label>
  }
  <div class="input-dropdown-container">
    <ng-select
      #ngSelect
      formControlName="select"
      [items]="options"
      bindLabel="label"
      bindValue="value"
      [class.disabled]="disabled"
      [placeholder]="placeholder"
      [notFoundText]="notFoundText"
      [compareWith]="compareWith"
      [appendTo]="appendTo()"
      [disabled]="disabled"
      (open)="openDropdown()"
      (close)="closeDropdown()"
      (change)="selectOption($event)"
      [searchable]="false"
      (blur)="onBlur()"
    >
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        <div class="option">
          <span>{{ item.label }}</span>
          @if (item.checked) {
          <mat-icon svgIcon="validate-xs"></mat-icon>
          }
        </div>
      </ng-template>
    </ng-select>

    @if (icon) {
    <mat-icon
      (mousedown)="toggleDropdown()"
      class="input-icon"
      [class.active]="dropdownOpened"
      [class.disabled]="disabled || formGroup.disabled"
      [svgIcon]="icon"
    >
    </mat-icon>
    }
  </div>
</ng-container>
